import { useEffect, useState } from "react";
import extendDataFetcher from "service/extend-data-fetcher";

const useExtendData = (isLoading, error, data) => {
    const [localData, setLocalData] = useState({});

    useEffect(() => {
        if (!isLoading && !error)
            fetcher(data.data);
    }, [isLoading, error, data])

    const fetcher = async serviceData => {
        const routes = [
            {
                identifier: "userData",
                url: `/api/identity/user/get?id=${serviceData.user_id}`,
                key: "mobile"
            }
        ];

        const newData = await extendDataFetcher(routes);
        setLocalData(newData);
    }

    return localData;
}

export default useExtendData;